import type { ReactNode } from "react";

export default function StudioSidebarCard(props: {
  title: string;
  eyebrow?: string;
  children: ReactNode;
  tone?: "default" | "blocked" | "accent";
}) {
  const toneStyles =
    props.tone === "blocked"
      ? {
          border: "1px solid rgba(162, 62, 62, 0.28)",
          background:
            "linear-gradient(180deg, rgba(255, 244, 241, 0.96), rgba(255, 250, 247, 0.96))",
        }
      : props.tone === "accent"
        ? {
            border: "1px solid rgba(41, 84, 103, 0.22)",
            background:
              "linear-gradient(180deg, rgba(240, 248, 250, 0.96), rgba(248, 251, 252, 0.98))",
          }
        : {
            border: "1px solid rgba(54, 44, 35, 0.12)",
            background: "rgba(255, 252, 248, 0.95)",
          };

  return (
    <section
      style={{
        ...toneStyles,
        borderRadius: 24,
        padding: "1.15rem 1.1rem",
        boxShadow: "0 16px 34px rgba(77, 61, 44, 0.08)",
      }}
    >
      {props.eyebrow ? (
        <div
          style={{
            fontSize: "0.72rem",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "#7b726a",
            marginBottom: "0.45rem",
            fontWeight: 700,
          }}
        >
          {props.eyebrow}
        </div>
      ) : null}
      <h2
        style={{
          margin: 0,
          fontSize: "1rem",
          color: "#2a2621",
          fontWeight: 700,
        }}
      >
        {props.title}
      </h2>
      <div style={{ marginTop: "0.85rem", color: "#4e463f", fontSize: "0.94rem" }}>
        {props.children}
      </div>
    </section>
  );
}